import { render, staticRenderFns } from "./DiagnosticDetailsHeader.vue?vue&type=template&id=fb686970&scoped=true"
import script from "./DiagnosticDetailsHeader.vue?vue&type=script&lang=js"
export * from "./DiagnosticDetailsHeader.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticDetailsHeader.vue?vue&type=style&index=0&id=fb686970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb686970",
  null
  
)

export default component.exports